var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFood(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 1C4.27614 1 4.5 1.22386 4.5 1.5V4.5C4.5 5.15311 4.9174 5.70873 5.5 5.91465V1.5C5.5 1.22386 5.72386 1 6 1C6.27614 1 6.5 1.22386 6.5 1.5V5.91465C7.0826 5.70873 7.5 5.15311 7.5 4.5V1.5C7.5 1.22386 7.72386 1 8 1C8.27614 1 8.5 1.22386 8.5 1.5V4.5C8.5 5.70948 7.64112 6.71836 6.5 6.94999V14.5C6.5 14.7761 6.27614 15 6 15C5.72386 15 5.5 14.7761 5.5 14.5V6.94999C4.35888 6.71836 3.5 5.70948 3.5 4.5V1.5C3.5 1.22386 3.72386 1 4 1ZM10.9786 2.47855C11.1376 2.31949 11.3169 2.19613 11.5 2.11452V7H10.5V3.5C10.5 3.16262 10.6737 2.78338 10.9786 2.47855ZM11.5 8V14.5C11.5 14.7761 11.7239 15 12 15C12.2761 15 12.5 14.7761 12.5 14.5V1.5C12.5 1.22386 12.2761 1 12 1C11.3374 1 10.7166 1.32627 10.2714 1.77145C9.82627 2.21662 9.5 2.83738 9.5 3.5V7.5C9.5 7.77614 9.72386 8 10 8H11.5Z",
    fill: "#424242"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFood);
export default __webpack_public_path__ + "static/media/food.823f8ad45ed6ed309d2078ab7a43db9f.svg";
export { ForwardRef as ReactComponent };